import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { WorkspaceProvider } from './context/WorkspaceContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AuthPage              from './pages/AuthPage';
import DashboardPage         from './pages/DashboardPage';
import ArtifactPage          from './pages/ArtifactPage';
import OnboardingPage        from './pages/OnboardingPage';
import OnboardingStreamPage  from './pages/OnboardingStreamPage';
import WorkspaceSettingsPage from './pages/WorkspaceSettingsPage';
import TasksPage             from './pages/TasksPage';
import TaskDetailPage        from './pages/TaskDetailPage';
import TaskOutputPage        from './pages/TaskOutputPage';
import DocumentsPage         from './pages/DocumentsPage';
import TermsPage         from './pages/TermsPage';
import PrivacyPage         from './pages/PrivacyPage';
import CeoMessagesPage from './pages/CEOMessagesPage'
import AdminAgentListPage   from './pages/admin/AdminAgentListPage';
import AdminAgentDetailPage from './pages/admin/AdminAgentDetailPage';
import AdminAgentNewPage    from './pages/admin/AdminAgentNewPage';
import AdminLogListPage from './pages/admin/AdminLogListPage';
import FeedbackPanel from './pages/FeedbackPanel';
import CeoRunLogPage from './pages/CeoRunLogPage';
import AdminFounderMessagesPage from './pages/admin/AdminFounderMessagesPage';
import WorkspaceProfilePage from './pages/WorkspaceProfilePage'
import NewBusinessPage from './pages/NewBusinessPage.js'
import ArtifactEditor from './pages/ArtifactEditor'
import FounderFeedPage from './pages/FounderFeedPage'
import './styles/global.css';
import CampaignPage from './pages/CampaignPage'
const AdminWorkspacesPage = React.lazy(() => import('./pages/admin/AdminWorkspacesPage'));
const AdminTasksPage      = React.lazy(() => import('./pages/admin/AdminTasksPage'));
const AdminTaskDetailPage = React.lazy(() => import('./pages/admin/AdminTaskDetailPage'));
const AdminArtifactsPage       = React.lazy(() => import('./pages/admin/AdminArtifactsPage'));
const AdminArtifactDetailPage  = React.lazy(() => import('./pages/admin/AdminArtifactDetailPage'));

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/"       element={<AuthPage />} />
          <Route path="/signup" element={<AuthPage tab="signup" />} />
          <Route path="/login"  element={<AuthPage tab="login" />} />
           <Route path="/terms"   element={<TermsPage />} />
           <Route path="/privacy" element={<PrivacyPage />} />

          {/* Protected */}
          <Route element={<ProtectedRoute />}>
            <Route element={<WorkspaceProvider><Outlet /></WorkspaceProvider>}>
              <Route path="/onboarding"              element={<OnboardingPage />} />
              <Route path="/onboarding/stream"       element={<OnboardingStreamPage />} />
              <Route path="/onboarding/idea"   element={<NewBusinessPage />} />    // mode=new idea form
              <Route path="/workspace/settings"      element={<WorkspaceSettingsPage />} />
              <Route path="/dashboard/tasks"         element={<TasksPage />} />
              <Route path="/dashboard/tasks/:taskId" element={<TaskDetailPage />} />
              <Route path="/dashboard/workspaces/:workspaceId/tasks/:taskId/output" element={<TaskOutputPage />} />
              <Route path="/dashboard"               element={<DashboardPage />} />
              <Route path="/dashboard/artifacts/:id" element={<ArtifactPage />} />
              <Route path="/dashboard/artifacts"     element={<DocumentsPage />} />
              <Route path="/dashboard/ceo_messages"     element={<CeoMessagesPage />} />
              <Route path="/dashboard/*"             element={<Navigate to="/dashboard" replace />} />
               <Route path="/workspace/profile" element={<WorkspaceProfilePage />} />
              {/* Admin — bundle-excluded in prod via lazy + env, runtime-guarded by isSuperAdmin */}
              <Route path="/admin" element={
                <Suspense fallback={null}><AdminWorkspacesPage /></Suspense>
              }/>
              <Route path="/admin/workspaces/:workspaceId" element={
                <Suspense fallback={null}><AdminTasksPage /></Suspense>
              }/>
              <Route path="/admin/workspaces/:workspaceId/tasks/:taskId" element={
                <Suspense fallback={null}><AdminTaskDetailPage /></Suspense>
              }/>
              <Route path="/admin/workspaces/:workspaceId/artifacts" element={
                  <Suspense fallback={null}><AdminArtifactsPage /></Suspense>
                }/>
                <Route path="/admin/workspaces/:workspaceId/artifacts/:artifactId" element={
                  <Suspense fallback={null}><AdminArtifactDetailPage /></Suspense>
                }/>
                <Route path="/admin/workspaces/:workspaceId/founder-messages" element={<AdminFounderMessagesPage />} />
                <Route path="/admin/agents"          element={<AdminAgentListPage />} />
                <Route path="/admin/agents/new"      element={<AdminAgentNewPage />} />
                <Route path="/admin/agents/:agentId" element={<AdminAgentDetailPage />} />
                <Route path="/admin/logs" element={<AdminLogListPage />} />
                <Route path="/dashboard/ceo-runlog" element={<CeoRunLogPage  />} />
                <Route path="/dashboard/feed" element={<FounderFeedPage />} />
                <Route path="/dashboard/artifacts/:id/edit" element={<ArtifactEditor />} />
                <Route path="/dashboard/campaigns/:id" element={<CampaignPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}